import request from './request'

export function listPriceList(data) {
  return request.post('/sales/price-lists/list', data)
}
export function getPriceList(id) {
  return request.get('/sales/price-lists/' + id)
}
export function effectivePrice(productId, bizDate) {
  return request.get('/sales/price-lists/effective', { params: { productId, bizDate } })
}
export function savePriceList(data) {
  return request.post('/sales/price-lists', data)
}
export function updatePriceList(data) {
  return request.post('/sales/price-lists/update', data)
}
export function deletePriceList(ids) {
  return request.post('/sales/price-lists/delete', ids)
}
